import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
pdfMake.vfs = pdfFonts.pdfMake.vfs;
export default {
  components: {},
  methods: {
    fc_getAppBase() {
      // return '/';
      return '/bot/';
    },
    fc_getDev() {
      if (window.location.hostname == 'localhost' && window.location.port == '8081') {
        return true;
      } else if (window.location.hostname == 'localhost') {
        return true;
      } else {
        return false;
      }
    },
    fc_getApiHost() {
      if (window.location.hostname == 'localhost' && window.location.port == '8081') {
        return 'http://localhost:8091/';
      } else if (window.location.hostname == 'localhost') {
        return 'http://localhost/api/';
      } else if (window.location.hostname.includes('ibasecanaldedenuncias.pt')) {
        if (window.location.hostname.includes('www.')) {
          return 'https://www.ibasecanaldedenuncias.pt' + this.fc_getAppBase() + 'api/';
        } else {
          return 'https://ibasecanaldedenuncias.pt' + this.fc_getAppBase() + 'api/';
        }
      } else if (window.location.hostname.includes('ibasewhistleblowing.pt')) {
        if (window.location.hostname.includes('www.')) {
          return 'https://www.ibasewhistleblowing.pt' + this.fc_getAppBase() + 'api/';
        } else {
          return 'https://ibasewhistleblowing.pt' + this.fc_getAppBase() + 'api/';
        }
      } else {
        if (window.location.hostname.includes('www.')) {
          return 'https://www.ibasejuridico.com' + this.fc_getAppBase() + 'api/';
        } else {
          return 'https://ibasejuridico.com' + this.fc_getAppBase() + 'api/';
        }
      }
    },
    fc_getUrlParam(param) {
      const queryString = window.location.href.split('?')[1];
      if (queryString) {
        const params = queryString.split('&');
        for (let i = 0; i < params.length; i++) {
          const pair = params[i].split('=');
          if (decodeURIComponent(pair[0]) == param) {
            return decodeURIComponent(pair[1]);
          }
        }
      }
      return null;
    },
    fc_go() {
      this.$router.go();
    },
    fc_goBack() {
      this.$router.go(-1);
    },
    fc_goForward() {
      this.$router.go(1);
    },
    fc_goRoute(name, params, query) {
      this.$router.push({ name: name, params: params, query: query });
    },
    fc_openModal(options) {
      this.$dialog.open(options.component, {
        props: {
          modal: (options.modal == null ? true : options.modal),
          closable: (options.closable == null ? true : options.closable),
          dismissableMask: (options.dismissableMask == null ? false : options.dismissableMask),
          position: (options.position == null ? 'center' : options.position),
          maximizable: (options.maximizable == null ? false : options.maximizable),
          draggable: (options.draggable == null ? false : options.draggable),
          header: options.header,
          style: (options.size == null || options.size == 'big' ? { width: '90vw' } : { width: '30vw' }),
          breakpoints: (options.size == null || options.size == 'big' ? null : { '1100px': '40vw', '960px': '50vw', '640px': '60vw', '440px': '80vw', }),
        },
        data: options.data,
        onClose: (closeOptions) => {
          if (options.onClose != null) {
            options.onClose();
          }
        }
      });
    },
    fc_confirmDialog(options) {
      this.$confirm.require({
        header: options.header,
        message: options.message,
        icon: options.icon,
        acceptClass: options.acceptClass,
        rejectClass: 'p-button-secondary',
        accept: () => {
          if (options.accept != null) {
            options.accept(options.data);
          }
        },
        reject: () => {
          if (options.reject != null) {
            options.reject(options.data);
          }
        }
      });
    },
    fc_getLang() {
      if (localStorage.lang != null) { return localStorage.lang; }
      else { return 'pt'; }
    },
    fc_setLang() {
      localStorage.lang = this.$store.state.lang;
    },
    fc_getIconSeverity(severity) {
      switch (severity) {
        case 'success': return 'pi-check-circle';
        case 'info': return 'pi-info-circle';
        case 'warn': return 'pi-exclamation-triangle';
        case 'error': return 'pi-times-circle';
        default: return 'pi-exclamation-circle';
      }
    },
    fc_validateNic(value) {
      if (value == null || value.length <= 0) {
        return true;
      } else {
        return new RegExp('^[0,1,2,3,4,5,6,7,8,9]{1,1}[0-9]{4,9}$').test(value);
      }
    },
    fc_validateNifSingulares(value) {
      if (value == null || value.length <= 0) {
        return true;
      } else {
        return new RegExp('^[1,2,3]{1,1}[0-9]{8,8}$').test(value);
      }
    },
    fc_validateNifColetivos(value) {
      if (value == null || value.length <= 0) {
        return true;
      } else {
        return new RegExp('^[1,2,3,5,6,7,8,9]{1,1}[0-9]{8,8}$').test(value);
      }
    },
    fc_validateTelemovel(value) {
      if (value == null || value.length <= 0) {
        return true;
      } else {
        return new RegExp('^[9,2]{1,1}[0-9]{8,8}$').test(value);
      }
    },
    fc_validateCodigoPostal(value) {
      if (value == null || value.length <= 0) {
        return true;
      } else {
        return new RegExp('^[0-9]{4,4}[-]{1,1}[0-9]{3,3}$').test(value);
      }
    },
    fc_validateIban(value) {
      if (value == null || value.length <= 0) {
        return true;
      } else {
        return new RegExp('^[a-zA-Z]{2}[0-9]{2}[a-zA-Z0-9]{4}[0-9]{7}([a-zA-Z0-9]?){0,16}$').test(value);
      }
    },
    fc_validateAlphanumeric(value) {
      if (value == null || value.length <= 0) {
        return true;
      } else {
        return new RegExp('^[a-zA-Z0-9]*$').test(value);
      }
    },
    fc_formatMoney(input) {
      let result = '';
      if (input != null && !isNaN(input)) {
        let n = 2, x = 3, s = ' ', c = ',', i = '€';
        let regex = '\\d(?=(\\d{' + (x || 3) + '})+' + (n > 0 ? '\\D' : '$') + ')';
        result = input.toFixed(Math.max(0, ~~n));
        result = (c ? result.replace('.', c) : input).replace(new RegExp(regex, 'g'), '$&' + (s || ',')) + ' ' + i;
      }
      return result;
    },
    fc_formatNumber(input) {
      let result = '';
      if (input != null && !isNaN(input)) {
        let n = 0, x = 3, s = '.', c = ',', i = '';
        let regex = '\\d(?=(\\d{' + (x || 3) + '})+' + (n > 0 ? '\\D' : '$') + ')';
        result = input.toFixed(Math.max(0, ~~n));
        result = (c ? result.replace('.', c) : input).replace(new RegExp(regex, 'g'), '$&' + (s || ',')) + ' ' + i;
      }
      return result;
    },
    fc_formatDateTime(input) {
      let result = '';
      if (input != null) {
        result = this.$dayjs(input).format('DD/MM/YYYY HH:mm:ss');
      }
      return result;
    },
    fc_formatDateTimeBr(input) {
      let result = '';
      if (input != null) {
        result = this.$dayjs(input).format('DD/MM/YYYY HH:mm:ss').replace(' ', '<br/>');
      }
      return result;
    },
    fc_formatDate(input) {
      let result = '';
      if (input != null) {
        result = this.$dayjs(input).format('DD/MM/YYYY');
      }
      return result;
    },
    fc_formatTime(input) {
      let result = '';
      if (input != null) {
        result = this.$dayjs(input).format('HH:mm:ss');
      }
      return result;
    },
    fc_formatZeros(num, size) {
      let result = '';
      if (num != null && !isNaN(num)) {
        let s = num + '';
        while (s.length < size) s = '0' + s;
        result = s;
      }
      return result;
    },
    fc_fetch(params) {
      const options = {
        method: params.method,
        headers: new Headers(),
        body: (params.body == null ? null : (!params.formData ? JSON.stringify(params.body) : params.body))
      };

      options.headers.append('Lang', this.$store.state.lang);
      options.headers.append('Accept', 'application/json');
      if (!params.formData) { options.headers.append('Content-Type', 'application/json'); }

      fetch(this.fc_getApiHost() + params.endpoint, options)
        .then((response) => {
          if (!response.ok) {
            response.text().then(x => {
              let json = x.length ? JSON.parse(x) : null;
              this.fc_fetchError(json, params.error);
            });
          } else {
            response.text().then(x => {
              let json = x.length ? JSON.parse(x) : {};
              this.fc_fetchSuccess(json, params.success);
            });
          }
        })
        .catch((error) => {
          this.fc_fetchError(null, params.error, error);
        });
    },
    fc_fetchSuccess(response, callback) {
      if (response.errors && response.errorsList && response.errorsList.length > 0) { this.fc_fetchErrors(response.errorsList) }
      if (response.messages && response.messagesList && response.messagesList.length > 0) { this.fc_fetchMessages(response.messagesList) }
      if (callback != null) { callback(response); }
    },
    fc_fetchError(response, callback, error) {
      if (response == null) {
        if (error != null) { console.log(error); }
        this.$toast.add({ severity: 'error', summary: this.$store.state.txt_app.error_generic_title, detail: this.$store.state.txt_app.error_generic_msg, life: 4000 });
      } else {
        if (response.exception) {
          this.$toast.add({ severity: 'error', summary: this.$store.state.txt_app.error_generic_title, detail: this.$store.state.txt_app.error_generic_msg, life: 4000 });
        } else {
          if (response.errors && response.errorsList && response.errorsList.length > 0) { this.fc_fetchErrors(response.errorsList) }
          else if (response.errors) { this.fc_fetchError(null, callback, response.errors); }
          else { this.fc_fetchError(null, callback, 'unhandled exception'); }
          if (response.messages && response.messagesList && response.messagesList.length > 0) { this.fc_fetchMessages(response.messagesList) }
        }
      }
      if (callback != null) { callback(response); }
    },
    fc_fetchMessages(messagesList) {
      messagesList.forEach((item, index) => {
        this.$toast.add({ severity: item.type, summary: item.title, detail: item.msg, life: 4000 });
      });
    },
    fc_fetchErrors(errorsList) {
      errorsList.forEach((item, index) => {
        this.$toast.add({ severity: 'error', summary: item.title, detail: item.msg, life: 4000 });
      });
    },
    fc_printErrors(error) {
      if (error != null && error.stack != null) { console.error('Error', error.stack); }
      else if (error != null && error.message != null) { console.error('Error', error.message); }
      else { console.error('Error', ''); }
    },
    fc_pdf(botClient, denuncia, referencia, password, data) {
      let docDefinition = {
        pageSize: 'A4',
        pageOrientation: 'portrait',
        pageMargins: [30, 100, 30, 40],
        info: {
          title: this.$store.state.txt_app.field_denuncia + ' ' + referencia,
          author: botClient.botPoweredBy,
          subject: botClient.botNomeEmpresa
        },
        header: (currentPage, pageCount, pageSize) => {
          return {
            layout: "noBorders",
            margin: [0, 0, 0, 0],
            table: {
              headerRows: 2,
              dontBreakRows: true,
              widths: ['*'],
              body: [
                [ { text: botClient.botNome, fontSize: 18, bold: true, fillColor: botClient.botCor01, color: '#fff', margin: [ 16, 8, 16, 8 ] } ],
                [ { text: botClient.botNomeEmpresa, fontSize: 12, bold: true, fillColor: botClient.botCor02, color: '#fff', margin: [ 16, 8, 16, 8 ] } ],
              ],
            },
          };
        },
        footer: (currentPage, pageCount, pageSize) => {
          return {
            layout: 'noBorders',
            margin: [0, 0, 0, 0],
            table: {
              headerRows: 1,
              dontBreakRows: true,
              widths: ['*'],
              body: [
                [ { text: ' ', fontSize: 10 } ],
                [ { text: [
                  { text: this.$store.state.txt_app.bt_poweredBy + ' ' },
                  { text: botClient.botPoweredBy, bold: true },
                ], fontSize: 10, alignment: 'center'  } ],
              ],
            },
          };
        },
        content: [
          {
            layout: 'noBorders',
            margin: [0, 0, 0, 0],
            table: {
              widths: ['*'],
              body: [],
            },
          },
        ],
      };

      let setorTxt = this.$store.state.param.setores.find(x => x.id == denuncia.setor).txt;
      let setorAreaTxt = this.$store.state.param.setoresAreas.find(x => x.id == denuncia.setorArea).txt;

      // Caro Denunciante,
      docDefinition.content[0].table.body.push(
        [ { text: this.$store.state.txt_app.pdf_text01, fontSize: 11 } ]
      );

      // Segue, o histórico da conversa que teve no nosso canal de denúncias interno
      docDefinition.content[0].table.body.push(
        [ { text: [
          { text: this.$store.state.txt_app.pdf_text02 + ' ' },
          { text: botClient.botNome, bold: true },
          { text: '.' },
        ], fontSize: 11  } ]
      );

      // espaço
      docDefinition.content[0].table.body.push(
        [ { text: ' ', fontSize: 8 } ]
      );

      // Pretende ser identificado?
      docDefinition.content[0].table.body.push(
        [ { text: [
          { text: this.$store.state.txt_app.pdf_text03 + '  ', bold: true },
          { text: (denuncia.anonimo ? this.$store.state.txt_app.bt_nao.toLowerCase() : this.$store.state.txt_app.bt_sim.toLowerCase()) },
        ], fontSize: 11  } ]
      );

      if (!denuncia.anonimo) {
        // Nome:
        docDefinition.content[0].table.body.push(
          [ { text: [
            { text: this.$store.state.txt_app.field_nome + '  ', bold: true },
            { text: denuncia.nome },
          ], fontSize: 11  } ]
        );
  
        // Empresa:
        docDefinition.content[0].table.body.push(
          [ { text: [
            { text: this.$store.state.txt_app.field_empresa + '  ', bold: true },
            { text: denuncia.empresa },
          ], fontSize: 11  } ]
        );
  
        // E-mail:
        docDefinition.content[0].table.body.push(
          [ { text: [
            { text: this.$store.state.txt_app.field_email + '  ', bold: true },
            { text: denuncia.email },
          ], fontSize: 11  } ]
        );
      }

      // espaço
      docDefinition.content[0].table.body.push(
        [ { text: ' ', fontSize: 8 } ]
      );

      // Empresa Denúnciada:
      docDefinition.content[0].table.body.push(
        [ { text: [
          { text: this.$store.state.txt_app.field_empresaDenunciada + '  ', bold: true },
          { text: botClient.botNomeEmpresa },
        ], fontSize: 11  } ]
      );

      // Setor da Denúncia:
      docDefinition.content[0].table.body.push(
        [ { text: [
          { text: this.$store.state.txt_app.field_setor + '  ', bold: true },
          { text: setorTxt },
        ], fontSize: 11  } ]
      );

      // Área da Denúncia:
      docDefinition.content[0].table.body.push(
        [ { text: [
          { text: this.$store.state.txt_app.field_setorArea + '  ', bold: true },
          { text: setorAreaTxt + (denuncia.setorArea == 16 ? ' (' + (denuncia.setorAreaOutro != null ? denuncia.setorAreaOutro : '') + ')' : '') },
        ], fontSize: 11  } ]
      );

      // espaço
      docDefinition.content[0].table.body.push(
        [ { text: ' ', fontSize: 8 } ]
      );

      // Denúncia:
      docDefinition.content[0].table.body.push(
        [ { text: this.$store.state.txt_app.field_denuncia, fontSize: 11, bold: true } ]
      );

      // Denúncia Texto
      docDefinition.content[0].table.body.push(
        [ { text: denuncia.denuncia, fontSize: 11 } ]
      );

      // Denúncia Texto Mais
      docDefinition.content[0].table.body.push(
        [ { text: denuncia.denunciaMais, fontSize: 11 } ]
      );

      // espaço
      docDefinition.content[0].table.body.push(
        [ { text: ' ', fontSize: 8 } ]
      );

      if (denuncia.files != null && denuncia.files.length > 0) {
        // Ficheiros Enviados:
        docDefinition.content[0].table.body.push(
          [ { text: this.$store.state.txt_app.field_ficheirosEnviados, fontSize: 11, bold: true } ]
        );

        for (let i = 0; i < denuncia.files.length; ++i) {
          docDefinition.content[0].table.body.push(
            [ { text: denuncia.files[i].name, fontSize: 11 } ]
          );
        }

        // espaço
        docDefinition.content[0].table.body.push(
          [ { text: ' ', fontSize: 8 } ]
        );
      }

      // Referência:
      docDefinition.content[0].table.body.push(
        [ { text: this.$store.state.txt_app.field_referencia, fontSize: 11, bold: true } ]
      );

      // Referência
      docDefinition.content[0].table.body.push(
        [ { text: referencia, fontSize: 11 } ]
      );

      // espaço
      docDefinition.content[0].table.body.push(
        [ { text: ' ', fontSize: 8 } ]
      );

      // Password:
      docDefinition.content[0].table.body.push(
        [ { text: this.$store.state.txt_app.field_password, fontSize: 11, bold: true } ]
      );

      // Password
      docDefinition.content[0].table.body.push(
        [ { text: password, fontSize: 11 } ]
      );

      // espaço
      docDefinition.content[0].table.body.push(
        [ { text: ' ', fontSize: 8 } ]
      );

      // Data da Denúncia:
      docDefinition.content[0].table.body.push(
        [ { text: this.$store.state.txt_app.field_dataDaDenuncia, fontSize: 11, bold: true } ]
      );

      // Data da Denúncia
      docDefinition.content[0].table.body.push(
        [ { text: this.fc_formatDate(data), fontSize: 11 } ]
      );

      // espaço
      docDefinition.content[0].table.body.push(
        [ { text: ' ', fontSize: 8 } ]
      );

      // Obrigado pelo seu contributo,
      docDefinition.content[0].table.body.push(
        [ { text: this.$store.state.txt_app.pdf_text04, fontSize: 11 } ]
      );

      // Nome da Empresa
      docDefinition.content[0].table.body.push(
        [ { text: botClient.botNomeEmpresa, fontSize: 11 } ]
      );

      // espaço
      docDefinition.content[0].table.body.push(
        [ { text: ' ', fontSize: 8 } ],
        [ { text: ' ', fontSize: 8 } ]
      );

      // Prazos:
      docDefinition.content[0].table.body.push(
        [ { text: this.$store.state.txt_app.field_prazos, fontSize: 9, color: '#444444', bold: true } ]
      );

      // Prazos
      docDefinition.content[0].table.body.push(
        [ { text: '- ' + this.$store.state.txt_app.prazos_text01, fontSize: 9, color: '#444444' } ],
        [ { text: '- ' + this.$store.state.txt_app.prazos_text02, fontSize: 9, color: '#444444' } ],
        [ { text: '- ' + this.$store.state.txt_app.prazos_text03, fontSize: 9, color: '#444444' } ],
        [ { text: '- ' + this.$store.state.txt_app.prazos_text04, fontSize: 9, color: '#444444' } ],
        [ { text: '- ' + this.$store.state.txt_app.prazos_text05, fontSize: 9, color: '#444444', margin: [30, 0, 0, 0] } ],
        [ { text: '- ' + this.$store.state.txt_app.prazos_text06, fontSize: 9, color: '#444444', margin: [30, 0, 0, 0] } ]
      );

      let win = window.open('loader.html', '_blank');
      setTimeout(() => {
        pdfMake.createPdf(docDefinition).open({}, win);
      }, 600);
    },
  }
}